import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { PhoneInput } from "@freightsimple/ui-core/Controls/PhoneInput";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { CreateAccountErrorMessages } from "@/Shared/Authentication/Hooks/useAuthenticationCreateAccount";

interface CreateAccountPageNameAndPhoneNumberProps {
  name: string;
  setName: (_: string) => void;
  phoneNumber: string;
  setPhoneNumber: (_: string) => void;
  phoneNumberExtension: string;
  setPhoneNumberExtension: (_: string) => void;
  forceValidation: boolean;
  errorMessages: CreateAccountErrorMessages;
}

export function AuthenticationCreateAccountPageNameAndPhoneNumber(
  props: CreateAccountPageNameAndPhoneNumberProps,
) {
  const {
    name,
    setName,
    phoneNumber,
    setPhoneNumber,
    phoneNumberExtension,
    setPhoneNumberExtension,
    forceValidation,
    errorMessages,
  } = props;

  return (
    <ShowFormErrors show={forceValidation}>
      <Stack gap={5}>
        <FormItem
          label="What is your full name?"
          fillWidth
          emphasizeLabel
          error={errorMessages.name}
        >
          <TextInput
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="signup_name"
            width="full"
          />
        </FormItem>
        <FormItem
          label="What is your direct phone number?"
          fillWidth
          emphasizeLabel
          error={errorMessages.phoneNumber}
        >
          <PhoneInput
            phoneNumber={phoneNumber}
            extension={phoneNumberExtension}
            onPhoneNumberChange={setPhoneNumber}
            onExtensionChange={setPhoneNumberExtension}
            width="full"
          />
        </FormItem>
      </Stack>
    </ShowFormErrors>
  );
}
